export function pushAddShippingInfo(shippingTier: string){
	if(typeof(window.gtm4wp_push_ecommerce) != 'function') return;
	window.gtm4wp_push_ecommerce( 'add_shipping_info', window.gtm4wp_checkout_products || [], {
		'currency': window.gtm4wp_currency || 'EUR',
		'shipping_tier': shippingTier,
		'value': window.gtm4wp_checkout_value || 0
	});
}

export function pushAddPaymentInfo(paymentMethodId: string|undefined){
	if(typeof(window.gtm4wp_push_ecommerce) != 'function' || !paymentMethodId) return;
	window.gtm4wp_push_ecommerce( 'add_payment_info', window.gtm4wp_checkout_products || [], {
		'currency': window.gtm4wp_currency || 'EUR',
		'payment_type': paymentMethodId,
		'value': window.gtm4wp_checkout_value || 0
	});
}